module.exports = __webpack_public_path__ + "img/back-girls.2897bbb5.png";